// extracted by mini-css-extract-plugin
export default {"social":"SocialMedia_social__kC3lS","socialLinks":"SocialMedia_socialLinks__0hD-e","icon":"SocialMedia_icon__eZYhs","line":"SocialMedia_line__TlKbQ"};